import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const messages = {
  en: {
    buttons: {
      skipRound: 'Skip Round',
      hide: "Hide",
      acquire: "Acquire",
      backToMenu: "Back To Menu",
      playAgain: "Play Again",
      close: "Close",
      configure: "Configure",
      save: "Save"
    },
    intro: {
      funnyGame: "This is funny game!",
      itIsLikePairs: "It's like playing pairs",
      switchOnTheSound: "just don't forget to switch on the sound",
      findThePairs: "And find pairs of birds just by their voices!"
    },
    setup: {
      players: "Players",
      togglePlayerCount: "Change to game for {count}",
      configuration: {
        header: "Set your own level!",
        detail: "Add at least two bird names and path to their voice recording",
        birdName: "Name",
        soundURL: "URL of the sound",
        play: "Play",
        stop: "Stop",
        ready: "Add",
        remove: "Remove",
        errors: {
          fileDuplicate: "Sound URLs must be unique",
          empty: "Sound filename can't be empty",
          wrong: "Sound filename must have at least 5 chars and end with .mp3 or .wav",
          notLoaded: "Can't download the file {path}"
        }
      }
    },
    levels: {
      level: "Level",
      contains: "Number of birds",
      example: "For example"
    },
    players: {
      winner: "WINNER",
      alreadyHas: "Already has {has}",
      needsToWin: "needs {needs} more to win",
      score: "Score"
    },
    cards: {
      licence: {
        header: "More about source data",
        detail: "The sound is licensed under Creative Commons. Click below to get the source and additional information.",
        link: "Go see original source"
      }
    },
    notifications: {
      cardAcquired: "{player} now got: {card}",
      won: "{player} is the winner!",
      tie: "It's a tie!",
      finished: "You have finished with score {score}!"
    }
  },
  cz: {
    buttons: {
      skipRound: 'Vynechat kolo',
      hide: "Otočit zpět",
      acquire: "Sebrat",
      backToMenu: "Zpět na nastavení",
      playAgain: "Hrát znovu",
      close: "Zavřít",
      configure: "Nastavit",
      save: "Uložit"
    },
    intro: {
      funnyGame: "Tohle je skvělá hra!",
      itIsLikePairs: "Je to jako hrát pexeso",
      switchOnTheSound: "jen si nezapomeň zapnout zvuk",
      findThePairs: "a najdi zvuky ptáků, co k sobě patří!"
    },
    setup: {
      players: "Budou hrát",
      togglePlayerCount: "Přepnout na hru pro {count}",
      configuration: {
        header: "Nastav si vlastní hru!",
        detail: "Přidej alespoň dva ptáčky: Jejich jména a odkaz na zvukovou nahrávku.",
        birdName: "Jméno",
        soundURL: "URL zvuku",
        play: "Test",
        stop: "Stop",
        ready: "Přidat",
        remove: "Odebrat",
        errors: {
          fileDuplicate: "Každý zvuk musí mít jinou URL",
          empty: "Chybí URL zvuku",
          wrong: "URL zvuku musí mít alespoň 5 znaků a končit .mp3 or .wav",
          notLoaded: "Nepovedlo se stáhnout zvuk {path}"
        }
      }
    },
    levels: {
      level: " Úroveň",
      contains: "Počet ptáčků",
      example: "Třeba"
    },
    players: {
      winner: "VÍTĚZSTVÍ",
      alreadyHas: "Už má {has}",
      needsToWin: "ještě potřebuje {needs}",
      score: "Bodů"
    },
    cards: {
      licence: {
        header: "O zdroji dat",
        detail: "Použitý zvuk má licenci Creative Commons. Klikni na odkaz a zjisti víc o autorovi a další info.",
        link: "Otevřít původní zdroj"
      }
    },
    notifications: {
      cardAcquired: "{player} teď má kartu: {card}",
      won: "Tuhle hru vyhrává {player}!",
      tie: "Je to remíza!",
      finished: "Hra je dohrána, máš {score} bodů!"
    }
  }
}

export const i18n = new VueI18n({
  locale: "cz",
  messages: messages
})



// WEBPACK FOOTER //
// ./src/i18n.js